function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var DomUtil = /*#__PURE__*/function () {
  function DomUtil() {
    _classCallCheck(this, DomUtil);
  }
  _createClass(DomUtil, null, [{
    key: "isEditElement",
    value:
    /**
     * 是否是一个可编辑的元素，也就是可以被 focus 的 element
     * @param element
     */
    function isEditElement(element) {
      if (!element) {
        return false;
      }
      var tags = ["INPUT", "TEXTAREA", "SELECT"];
      if (tags.includes(element.tagName) && !element.disabled) {
        return true;
      }
      return element.contenteditable === "true";
    }
  }, {
    key: "hasTheme",
    value: function hasTheme(element, themeType) {
      var currentElement = element.parentElement;
      while (currentElement) {
        var dataThemeValue = currentElement.getAttribute("data-theme");
        if (dataThemeValue === themeType) {
          return true;
        }
        currentElement = currentElement.parentElement;
      }
      return false;
    }
  }, {
    key: "hasAttr",
    value: function hasAttr(element, attr, value) {
      var currentElement = element;
      while (currentElement) {
        var dataValue = currentElement.getAttribute(attr);
        if (dataValue === value) {
          return true;
        }
        currentElement = currentElement.parentElement;
      }
      return false;
    }

    /**
     * 判断元素是否滚到到了最底部
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight
     * @param target
     * @returns
     */
  }, {
    key: "hasScrollToBottom",
    value: function hasScrollToBottom(target) {
      var contentScrollTop = target.scrollTop; // 滚动条距离顶部
      var clientHeight = target.clientHeight; // 可视区域
      var scrollHeight = target.scrollHeight; // 滚动条内容的总高度
      // scrolltop 是一个不精准的小数
      // FIXME: -1 为了保证准确
      return Math.round(contentScrollTop + clientHeight) >= scrollHeight - 1;
    }
  }, {
    key: "getStringWordLength",
    value: function getStringWordLength(text) {
      var reg = /\s|\n/g;
      return text.split(reg).filter(function (x) {
        return x;
      }).length;
    }
  }]);
  return DomUtil;
}();